import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { defineAsyncComponent, ref, h } from "vue";

// Dynamically import Vue3Lottie only on client side

export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'LottieWrapper',
  emits: ["on-animation-loaded"],
  setup(__props, { expose: __expose, emit: __emit }) {

const Vue3Lottie = defineAsyncComponent({
  loader: () => import("vue3-lottie").then((module) => module.Vue3Lottie),
  delay: 200,
  timeout: 3000,
  suspensible: false,
  loadingComponent: {
    render: () =>
      h("div", { class: "w-full h-full bg-neutral-100 dark:bg-neutral-800 animate-pulse rounded" }),
  },
  // errorComponent: {
  //   render: () => h('div', { class: 'w-full h-full bg-red-100 dark:bg-red-800 rounded flex items-center justify-center text-red-500' }, 'Failed to load animation')
  // },
});

const lottieRef = ref();

// Emit the animation loaded event to parent
const emit = __emit;

const onAnimationLoaded = (...args: any[]) => {
  emit("on-animation-loaded", ...args);
};

// Expose methods so parent components can call them
const goToAndPlay = (...args: any[]) => {
  if (lottieRef.value?.goToAndPlay) {
    return lottieRef.value.goToAndPlay(...args);
  }
};

const pause = (...args: any[]) => {
  if (lottieRef.value?.pause) {
    return lottieRef.value.pause(...args);
  }
};

const play = (...args: any[]) => {
  if (lottieRef.value?.play) {
    return lottieRef.value.play(...args);
  }
};

const stop = (...args: any[]) => {
  if (lottieRef.value?.stop) {
    return lottieRef.value.stop(...args);
  }
};

// Expose the methods for template refs
__expose({
  goToAndPlay,
  pause,
  play,
  stop,
  lottieRef,
});



return (_ctx: any,_cache: any) => {
  const _component_ClientOnly = _resolveComponent("ClientOnly")!

  return (_openBlock(), _createBlock(_component_ClientOnly, null, {
    fallback: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "w-full h-full bg-gray-100 dark:bg-gray-800 animate-pulse rounded" }, null, -1)
    ]))]),
    default: _withCtx(() => [
      (_unref(Vue3Lottie))
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(Vue3Lottie)), _mergeProps({
            key: 0,
            ref_key: "lottieRef",
            ref: lottieRef
          }, _ctx.$attrs, { onOnAnimationLoaded: onAnimationLoaded }), null, 16))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})